var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-tabs",
        { attrs: { value: "common" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Common", name: "common" } },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "element-loading-spinner": "el-icon-loading",
                    "label-width": "170px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Brand", prop: "brand_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.form.brand_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "brand_id", $$v)
                            },
                            expression: "form.brand_id",
                          },
                        },
                        _vm._l(_vm.brandOptions, function ({ value, label }) {
                          return _c("el-option", {
                            key: value,
                            attrs: { value: value, label: label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Name", prop: "name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Signature", prop: "signature" } },
                    [
                      _c("tinymce-editor", {
                        ref: "signature",
                        attrs: { id: "signature" },
                        model: {
                          value: _vm.form.signature,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "signature", $$v)
                          },
                          expression: "form.signature",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "placeholders",
                        {
                          attrs: { items: _vm.placeholders },
                          on: { select: _vm.addPlaceholder },
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "Placeholders",
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "color--prpl cursor-pointer" },
                                [_c("i", { staticClass: "fas fa-code" })]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-purple px-4",
                  on: { click: _vm.store },
                },
                [_vm._v("Store")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isEditMode
            ? _c(
                "el-tab-pane",
                { attrs: { label: "User Bindings", name: "binding" } },
                [
                  _c(
                    "users-table",
                    _vm._b({}, "users-table", _vm.usersTableAttrs, false)
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }